module.exports = __webpack_public_path__ + "img/22.6a708e54.gif";